import { useDispatch, useSelector } from 'react-redux';

import { PLAN_TYPE, setPlan } from '@/store/checkout';

import { getVatValues } from './utils';

export const usePlansOptions = () => {
	return [PLAN_TYPE.TRIAL, PLAN_TYPE.MONTHLY];
};

export const isFeatureChecked = (planName, featureIndex) =>
	planName !== 'trial' || featureIndex >= 5;

export function usePlan() {
	const dispatch = useDispatch();

	const {
		initializing,
		ready,
		prices,
		priceId,
		fullPlan,
		currentPlan,
		vatInfo,
		currency,
		fetchingPrices,
		monthlyPlan,
		discount
	} = useSelector(state => {
		const {
			prices: pricesList,
			priceId: selectedPrice,
			initCheckout = {},
			getPrices = {}
		} = state.checkout;

		const userDiscount = state.auth?.user?.discount;

		const { country, type: accountType } =
			state.profile.user?.taxInformation || {};

		const foundCurrentPlan =
			pricesList.find(price => price.handlerId === selectedPrice) || {};

		return {
			initializing: initCheckout?.loading,
			ready: initCheckout?.success,
			prices: pricesList,
			priceId: selectedPrice,
			vatInfo: getVatValues(foundCurrentPlan, { country, accountType }),
			currentPlan: foundCurrentPlan,
			currency: state.profile.currency,
			fetchingPrices: getPrices?.loading,
			discount: userDiscount,
			monthlyPlan: pricesList.find(
				item => item.active && item.name === 'monthly'
			)
		};
	});

	return {
		initializing,
		ready,
		prices,
		priceId,
		setPriceId: id => dispatch(setPlan(id)),
		fullPlan,
		currentPlan,
		vatInfo,
		currency,
		fetchingPrices,
		monthlyPlan,
		discount
	};
}
